import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "viewer-tools" }
const _hoisted_2 = { id: "zoom_scale_panel" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<button id=\"zoom_x40\" value=\"40\" type=\"button\" class=\"zoom_btn_value\">40x</button><button id=\"zoom_x20\" value=\"20\" type=\"button\" class=\"zoom_btn_value\">20x</button><button id=\"zoom_x10\" value=\"10\" type=\"button\" class=\"zoom_btn_value\">10x</button><button id=\"zoom_x4\" value=\"4\" type=\"button\" class=\"zoom_btn_value\">4x</button><button id=\"zoom_x2\" value=\"2\" type=\"button\" class=\"zoom_btn_value\">2x</button><button id=\"zoom_x1\" value=\"1\" type=\"button\" class=\"zoom_btn_value\">1x</button><div id=\"empty\" class=\"zoom_btn_style btn_common\" style=\"background-color:transparent;margin-bottom:-28px;\"></div>", 7)
const _hoisted_11 = [
  _hoisted_4
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  class: "zoom_btn_style",
  id: "zoom_btn"
}, null, -1)
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  id: "FOV-insert"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { id: "measuring-tool-insert" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: "zoom_buttons_panel",
        title: _ctx.t('magnification.zoom_level')
      }, _hoisted_11, 8, _hoisted_3),
      _hoisted_12
    ]),
    _createElementVNode("span", {
      id: "zoom_text",
      title: _ctx.t('zoomLevelTitle')
    }, null, 8, _hoisted_13),
    (_ctx.config.enable_viewer_fov)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
      : _createCommentVNode("", true),
    _hoisted_15
  ]))
}